export default "/images/bc93fc7f54450d80d8e2bfbeb2eaa9ef.avif";